function runWhenIdle(fn) {
  if (typeof requestIdleCallback !== 'undefined') {
    requestIdleCallback(fn, { timeout: 1500 });
  } else {
    setTimeout(fn, 0);
  }
}

document.addEventListener('DOMContentLoaded', function() {
  runWhenIdle(initializeToggleCollectionSection);
});

document.addEventListener('section:lazy-load', function(event) {
  const section = event.target;
  if (section && section.querySelector && section.querySelector('.sunice-toggle-collection-list')) {
    runWhenIdle(initializeToggleCollectionSection);
  }
});

function initializeToggleCollectionSection() {
  if (!document.querySelector('.sunice-toggle-collection-list, .sunice-toggle-collection-swiper')) return;
  try {
    initToggleButtons();
    initializeCarousels();
    setupMobileCollectionClick();
    setupOverlayHeadingHover();
    setupThemeEditorListeners();
  } catch (error) {
    // Error initializing Toggle Collection Section
  }
}

// Mobile click handler for collection list blocks (749px and below)
function setupMobileCollectionClick() {
  const collectionBlocks = document.querySelectorAll('.collection-list-block.child-link-hover');
  
  collectionBlocks.forEach(block => {
    // Main block click handler
    block.addEventListener('click', function(e) {
      // Only apply on mobile (749px and below)
      if (window.innerWidth <= 749) {
        // Don't trigger if clicking on the close button or overlay content
        if (e.target.closest('.close-overlay') || e.target.closest('.collection-list-block__overlay-content')) {
          return;
        }
        
        // Remove active class from all other collection blocks
        collectionBlocks.forEach(otherBlock => {
          if (otherBlock !== block) {
            otherBlock.classList.remove('collection-list-block--active');
          }
        });
        
        // Add active class to clicked block (this will show the overlay)
        block.classList.add('collection-list-block--active');
      }
    });
    
    // Close overlay button handler
    const closeButton = block.querySelector('.close-overlay');
    if (closeButton) {
      closeButton.addEventListener('click', function(e) {
        e.stopPropagation(); // Prevent triggering the block click
        
        // Remove active class to hide overlay
        block.classList.remove('collection-list-block--active');
      });
    }
  });
  
  // Handle resize events to remove active states on desktop and update toggle button active state
  let resizeTimeout;
  window.addEventListener('resize', function() {
    if (window.innerWidth > 749) {
      document.querySelectorAll('.collection-list-block.child-link-hover').forEach(block => {
        block.classList.remove('collection-list-block--active');
      });
    }
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateToggleButtonsActiveState, 100);
  });
}

// Update toggle-buttons__active-state position/size when screen resizes (buttons may change size)
function updateToggleButtonsActiveState() {
  document.querySelectorAll('.sunice-toggle-collection-list .toggle-buttons').forEach((container) => {
    const activeState = container.querySelector('.toggle-buttons__active-state');
    const activeButton = container.querySelector('.toggle-buttons__button.active');
    if (activeState && activeButton) {
      setActiveButton(activeButton, activeState);
    }
  });
}

// Initialize carousels in the section
function initializeCarousels() {
  // Only target toggle collection swipers, not product grid swipers
  const carousels = document.querySelectorAll('.sunice-toggle-collection-swiper:not([data-initialized])');
  carousels.forEach(carousel => {
    // Skip if this is a product grid swiper
    if (carousel.classList.contains('sunice-product-grid-swiper')) {
      return;
    }
    
    carousel.setAttribute('data-initialized', 'true');
    
    if (window.SuniceToggleCollectionSwiper) {
      const toggleCollectionSwiper = window.SuniceToggleCollectionSwiper.getInstance
        ? window.SuniceToggleCollectionSwiper.getInstance()
        : new window.SuniceToggleCollectionSwiper();
      toggleCollectionSwiper.initializeToggleCollectionSwiper(carousel);
    } else {
      // Fallback to basic Swiper initialization
      if (window.Swiper && carousel.swiper) {
        carousel.swiper.destroy(true, true);
      }
      
      if (window.Swiper) {
        const swiper = new Swiper(carousel, {
          slidesPerView: 'auto',
          spaceBetween: 12,
          loop: carousel.dataset.infinite === 'true',
          autoplay: false,
          navigation: {
            nextEl: carousel.closest('.swiper-container-wrapper').querySelector('.slideshow-control--next'),
            prevEl: carousel.closest('.swiper-container-wrapper').querySelector('.slideshow-control--previous'),
          },
          breakpoints: {
            768: {
              spaceBetween: parseInt(carousel.closest('.resource-list').style.getPropertyValue('--resource-list-column-gap-desktop')) || 12,
            }
          }
        });
        
        // Store reference for later cleanup
        carousel.swiper = swiper;
      }
    }
  });
}

// Cleanup function for theme editor updates
function cleanupToggleCollectionSection() {
  const carousels = document.querySelectorAll('.sunice-toggle-collection-swiper[data-initialized]');
  carousels.forEach(carousel => {
    if (carousel.swiper) {
      carousel.swiper.destroy(true, true);
      carousel.swiper = null;
    }
    carousel.removeAttribute('data-initialized');
  });

  // Also clear instances from the singleton so stale refs don't block reinit
  if (window.SuniceToggleCollectionSwiper) {
    const instance = window.SuniceToggleCollectionSwiper.getInstance
      ? window.SuniceToggleCollectionSwiper.getInstance()
      : null;
    if (instance && instance.swiperInstances) {
      instance.swiperInstances.forEach((swiper, id) => {
        if (swiper && !swiper.destroyed && swiper.destroy) {
          try { swiper.destroy(true, true); } catch (e) {}
        }
      });
      instance.swiperInstances.clear();
    }
  }
  
  // Remove initialization from toggle buttons
  const toggleButtons = document.querySelectorAll('.toggle-buttons__button[data-initialized]');
  toggleButtons.forEach(button => {
    button.removeAttribute('data-initialized');
    button.removeEventListener('click', handleToggleClick);
  });
}

function activateCollectionBlock(slideValue) {
  // Remove active class from all collection-list-item-block parent elements
  const allCollectionBlocks = document.querySelectorAll('.collection-list-item-block__inner');
  allCollectionBlocks.forEach(block => {
    block.parentElement.classList.remove('active');
  });
  
  // Add active class to the parent of the matching collection-list-item-block
  const targetBlock = document.querySelector(`.collection-list-item-block__inner[data-slide="${slideValue}"]`);
  if (targetBlock) {
    targetBlock.parentElement.classList.add('active');
    // Swiper was inited while hidden (0 width). Rebuild loop with real size so nav + loop work.
    const swiperEl = targetBlock.querySelector('.sunice-toggle-collection-swiper');
    if (swiperEl && swiperEl.swiper && !swiperEl.swiper.destroyed) {
      requestAnimationFrame(() => {
        const s = swiperEl.swiper;
        try {
          s.update();
          if (s.params.loop && s.loopDestroy && s.loopCreate) {
            s.loopDestroy();
            s.loopCreate();
            s.update();
          }
        } catch (e) {}
      });
    }
  }
}

function handleSlideChange(slideValue) {
  // Add your carousel slide change logic here
  // Example: You could trigger carousel navigation or show/hide specific slides
  // const carousel = document.querySelector('.resource-list__carousel');
  // if (carousel) {
  //   // Your carousel logic here
  // }
}

// Guard: avoid redefining the custom element in Theme Editor
if (!customElements.get('section-sunice-toggle-collection-list')) {
class SectionSuniceToggleCollectionList extends HTMLElement {
  connectedCallback() {
    // Fallback initialization
    setTimeout(() => {
      initToggleButtons();
    }, 100);
  }

  disconnectedCallback() {
  }

  handleSlideChange(slideValue) {
    // Add your carousel slide change logic here
    // Example: You could trigger carousel navigation or show/hide specific slides
    // const carousel = this.querySelector('.resource-list__carousel');
    // if (carousel) {
    //   // Your carousel logic here
    // }
  }

  static get observedAttributes() {
    return ['data-slide'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
  }
}

customElements.define('section-sunice-toggle-collection-list', SectionSuniceToggleCollectionList);
}

// Theme Editor Real-time Updates
function setupThemeEditorListeners() {
  // Only set up listeners if we're in theme editor mode
  if (!window.Shopify || !window.Shopify.designMode) {
    return;
  }
  // Guard: bind once in Theme Editor
  if (window.__suniceToggleListBound) return;
  window.__suniceToggleListBound = true;

  // Listen for section updates from theme editor
  document.addEventListener('shopify:section:load', (event) => {
    const sectionId = event.detail.sectionId;
    const section = document.querySelector(`[data-section-id="${sectionId}"]`);
    
    if (section && section.classList.contains('ui-test-collection-list')) {
      // Cleanup first, then re-initialize
      cleanupToggleCollectionSection();
      setTimeout(() => {
        initializeToggleCollectionSection();
        // Rebuild toggle buttons to reflect any title changes
        setTimeout(() => { try { rebuildToggleButtons(section); ensureActiveUI(section); } catch(e) {} }, 50);
      }, 100);
    }
  });

  // Listen for section updates
  document.addEventListener('shopify:section:reorder', (event) => {
    const sectionId = event.detail.sectionId;
    const section = document.querySelector(`[data-section-id="${sectionId}"]`);
    
    if (section && section.classList.contains('ui-test-collection-list')) {
      cleanupToggleCollectionSection();
      setTimeout(() => {
        initializeToggleCollectionSection();
        setTimeout(() => { try { rebuildToggleButtons(section); ensureActiveUI(section); } catch(e) {} }, 50);
      }, 100);
    }
  });

  // Listen for block updates
  document.addEventListener('shopify:block:select', (event) => {
    const sectionId = event.detail.sectionId;
    const section = document.querySelector(`[data-section-id="${sectionId}"]`);
    
    if (section && section.classList.contains('ui-test-collection-list')) {
      highlightBlock(event.detail.blockId, section);
      // Rebuild buttons -> reflect updated title immediately
      setTimeout(() => { try { rebuildToggleButtons(section); ensureActiveUI(section); } catch(e) {} }, 25);
    }
  });

  document.addEventListener('shopify:block:deselect', (event) => {
    const sectionId = event.detail.sectionId;
    const section = document.querySelector(`[data-section-id="${sectionId}"]`);
    
    if (section && section.classList.contains('ui-test-collection-list')) {
      removeBlockHighlight(section);
      setTimeout(() => { try { rebuildToggleButtons(section); ensureActiveUI(section); } catch(e) {} }, 25);
    }
  });

  // Listen for section settings changes
  document.addEventListener('shopify:section:select', (event) => {
    const sectionId = event.detail.sectionId;
    const section = document.querySelector(`[data-section-id="${sectionId}"]`);
    
    if (section && section.classList.contains('ui-test-collection-list')) {
      // Re-initialize to ensure everything is working
      cleanupToggleCollectionSection();
      setTimeout(() => {
        initializeToggleCollectionSection();
        setTimeout(() => { try { rebuildToggleButtons(section); ensureActiveUI(section); } catch(e) {} }, 50);
      }, 100);
    }
  });
}

function updateSectionFromThemeEditor(detail) {
  const sectionId = detail.sectionId;
  const section = document.querySelector(`[data-section-id="${sectionId}"]`);
  
  if (!section) return;

  // Update section content when theme editor changes
  if (detail.sectionHTML) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = detail.sectionHTML;
    const newSection = tempDiv.querySelector(`[data-section-id="${sectionId}"]`);
    
    if (newSection) {
      // Update the section content
      section.innerHTML = newSection.innerHTML;
      
      // Reinitialize toggle buttons after content update
      setTimeout(() => {
        initToggleButtons();
      }, 100);
      
      // Update CSS variables if they changed
      updateCSSVariables(detail.settings, section);
    }
  }
}

function updateCSSVariables(settings, section) {
  if (!settings || !section) return;

  // Update CSS custom properties based on settings
  if (settings.columns_gap !== undefined) {
    section.style.setProperty('--resource-list-column-gap-desktop', settings.columns_gap + 'px');
  }
  
  if (settings.columns !== undefined) {
    section.style.setProperty('--column-count', settings.columns);
  }
  
  if (settings.gap !== undefined) {
    section.style.setProperty('--section-gap', settings.gap + 'px');
  }
  
  if (settings.bento_gap !== undefined) {
    section.style.setProperty('--bento-gap', settings.bento_gap + 'px');
  }
  
  if (settings.rows_gap !== undefined) {
    section.style.setProperty('--rows-gap', settings.rows_gap + 'px');
  }
}

function highlightBlock(blockId, section) {
  const block = section.querySelector(`[data-block-id="${blockId}"]`);
  if (block) {
    block.classList.add('theme-editor-highlight');
  }
}

function removeBlockHighlight(section) {
  const highlightedBlocks = section.querySelectorAll('.theme-editor-highlight');
  highlightedBlocks.forEach(block => {
    block.classList.remove('theme-editor-highlight');
  });
}

// Enhanced toggle button functionality with theme editor support
function initToggleButtons() {
  // Only select toggle buttons that are NOT inside the size guide modal
  const toggleButtons = document.querySelectorAll('.toggle-buttons__button:not([data-initialized]):not([data-category]):not([data-unit])');
  
  // Initialize each button
  toggleButtons.forEach(button => {
    button.setAttribute('data-initialized', 'true');
    button.removeEventListener('click', handleToggleClick);
    button.addEventListener('click', handleToggleClick);
  });
  
  // Set first button as active by default if no button is currently active
  if (toggleButtons.length > 0) {
    const container = toggleButtons[0].closest('.toggle-buttons');
    const hasActive = container?.querySelector('.toggle-buttons__button.active');
    
    if (!hasActive) {
      const firstButton = toggleButtons[0];
      const activeState = container?.querySelector('.toggle-buttons__active-state');
      if (activeState) {
        setActiveButton(firstButton, activeState);
        
        // Also activate the corresponding collection-list-item-block
        const firstSlideValue = firstButton.getAttribute('data-slide');
        if (firstSlideValue) {
          activateCollectionBlock(firstSlideValue);
        }
      }
    }
  }
}

function handleToggleClick(event) {
  event.preventDefault();
  
  const button = event.currentTarget;
  // Find active state within the same container
  const container = button.closest('.toggle-buttons');
  const activeState = container?.querySelector('.toggle-buttons__active-state');
  
  if (!activeState) return;

  // Update active button
  setActiveButton(button, activeState);
  
  // Get the data-slide value
  const slideValue = button.getAttribute('data-slide');
  
  if (slideValue) {
    handleSlideChange(slideValue);
    activateCollectionBlock(slideValue);
  }
}

function setActiveButton(button, activeState) {
  // Remove active class from buttons in the same container only
  const container = button.closest('.toggle-buttons');
  if (!container) return;
  
  const containerButtons = container.querySelectorAll('.toggle-buttons__button');
  containerButtons.forEach(btn => btn.classList.remove('active'));
  
  // Add active class to clicked button
  button.classList.add('active');
  
  // Update active state indicator position with smooth transition
  const buttonRect = button.getBoundingClientRect();
  const containerRect = container.getBoundingClientRect();
  const offsetLeft = buttonRect.left - containerRect.left;
  
  activeState.style.transform = `translateX(${offsetLeft}px)`;
  activeState.style.width = `${buttonRect.width}px`;
  activeState.style.height = `${buttonRect.height}px`;
}

// Ensure the active-state element exists and one button/block is active
function ensureActiveUI(scope){
  const root = scope || document;
  const container = root.querySelector('.toggle-buttons');
  if (!container) return;
  let activeState = container.querySelector('.toggle-buttons__active-state');
  if (!activeState){
    activeState = document.createElement('span');
    activeState.className = 'toggle-buttons__active-state';
    container.prepend(activeState);
  }
  const buttons = container.querySelectorAll('.toggle-buttons__button');
  if (!buttons.length) return;
  let current = container.querySelector('.toggle-buttons__button.active') || buttons[0];
  const btnRect = current.getBoundingClientRect();
  const cRect = container.getBoundingClientRect();
  activeState.style.transform = `translateX(${btnRect.left - cRect.left}px)`;
  activeState.style.width = `${btnRect.width}px`;
  activeState.style.height = `${btnRect.height}px`;
  buttons.forEach(b => b.classList.remove('active'));
  current.classList.add('active');
  const slideValue = current.getAttribute('data-slide');
  if (slideValue) activateCollectionBlock(slideValue);
}

// Rebuild toggle buttons from current blocks in the section (Theme Editor only)
function rebuildToggleButtons(section){
  if (!window.Shopify || !window.Shopify.designMode) return;
  const root = section || document.querySelector('.sunice-toggle-collection-list');
  if (!root) return;
  const container = root.querySelector('.toggle-buttons');
  if (!container) return;

  const prevActive = container.querySelector('.toggle-buttons__button.active')?.getAttribute('data-slide');
  const blockInners = Array.from(root.querySelectorAll('.collection-list-item-block__inner'));
  if (!blockInners.length) return;

  const titles = [];
  blockInners.forEach(el => {
    const v = (el.getAttribute('data-slide') || '').trim();
    if (v && !titles.includes(v)) titles.push(v);
  });
  if (!titles.length) return;

  let activeState = container.querySelector('.toggle-buttons__active-state');
  if (!activeState){
    activeState = document.createElement('span');
    activeState.className = 'toggle-buttons__active-state';
    container.innerHTML = '';
    container.appendChild(activeState);
  } else {
    container.querySelectorAll('.toggle-buttons__button').forEach(b => b.remove());
  }

  titles.forEach(t => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'toggle-buttons__button';
    btn.setAttribute('data-slide', t);
    btn.textContent = t.toUpperCase();
    container.appendChild(btn);
  });

  container.querySelectorAll('.toggle-buttons__button').forEach(button => {
    button.setAttribute('data-initialized', 'true');
    button.removeEventListener('click', handleToggleClick);
    button.addEventListener('click', handleToggleClick);
  });

  const targetBtn = prevActive ? container.querySelector(`.toggle-buttons__button[data-slide="${prevActive}"]`) : container.querySelector('.toggle-buttons__button');
  if (targetBtn) {
    setActiveButton(targetBtn, activeState);
    const sv = targetBtn.getAttribute('data-slide');
    if (sv) activateCollectionBlock(sv);
  }
}

// Simulate hover effect on mobile when tapping overlay heading
function setupOverlayHeadingHover(){
  const activateBlock = (el) => {
    const block = el.closest('.collection-list-block.child-link-hover');
    if (!block) return;
    // On mobile, mirror the same behavior as tapping the card
    // Remove active from siblings within the same section
    const section = block.closest('.sunice-toggle-collection-list');
    if (section) {
      section.querySelectorAll('.collection-list-block.collection-list-block--active').forEach(b => {
        if (b !== block) b.classList.remove('collection-list-block--active');
      });
    }
    block.classList.add('collection-list-block--active');
  };

  // Pointer events cover both mouse and touch
  document.addEventListener('pointerdown', (e) => {
    const h3 = e.target.closest && e.target.closest('.collection-list-block__overlay h3');
    if (h3) {
      activateBlock(h3);
    }
  }, { passive: true });

  document.addEventListener('click', (e) => {
    const h3 = e.target.closest && e.target.closest('.collection-list-block__overlay h3');
    if (h3) {
      activateBlock(h3);
    }
  }, { passive: true });
}

// Register with theme editor system for automatic re-initialization
if (window.registerThemeEditorComponent) {
  window.registerThemeEditorComponent(initializeToggleCollectionSection, 'toggle-collection-section');
}